import React from "react";

import MomentViewProps from "./props";

const MomentItem: React.FC<MomentViewProps> = (props: MomentViewProps) => {
  return <>{props.value.format(props.format ?? "YYYY-MM-DD HH:mm:ss")}</>;
};

export default MomentItem;
